<div class="flex justify-center gap-1 flex-col lg:flex-row">
  <div class="flex gap-4">
    <app-products-colection [supply]="ticketPendingSupply" [small]="mobile">
    </app-products-colection>
    <div class="flex-col gap-4 lg:flex! hidden">
      <div class="text-general flex flex-col">
        @if (ticketPendingSupply[0]) {
          <div>1: {{ ticketPendingSupply[0]?.Supply?.Description }}</div>
        }
        @if (ticketPendingSupply[1]) {
          <div>2: {{ ticketPendingSupply[1]?.Supply?.Description }}</div>
        }
        @if (ticketPendingSupply[2]) {
          <div>3: {{ ticketPendingSupply[2]?.Supply?.Description }}</div>
        }
        @if (ticketPendingSupply[3]) {
          <div>...</div>
        }
      </div>
      <div class="flex flex-col gap-2">
        <div class="text-general-title">Total ${{ totalAmount.toFixed(2) }}</div>
        <div class="flex gap-2">
          <div class="text-general-subtitle">Tiempo estimado de entrega 23 min.</div>
          @if (viewMap) {
            <button (click)="openMap()" class="button-general-border w-50" matButton="filled">
              Ver Mapa
            </button>
          }
        </div>
      </div>
    </div>

    <div class="lg:hidden flex lg:px-3 flex-col">
      <div class="text-general flex flex-col">
        <div class="text-general flex flex-col">
          @if (ticketPendingSupply[0]) {
            <div>1: {{ ticketPendingSupply[0]?.Supply?.Description }}</div>
          }
          @if (ticketPendingSupply[1]) {
            <div>2: {{ ticketPendingSupply[1]?.Supply?.Description }}</div>
          }
          @if (ticketPendingSupply[2]) {
            <div>3: {{ ticketPendingSupply[2]?.Supply?.Description }}</div>
          }
          @if (ticketPendingSupply[3]) {
            <div>...</div>
          }
        </div>
        <div class="text-general-title">Total ${{ totalAmount.toFixed(2) }}</div>
        <div class="flex justify-between items-center">
          <div class="text-general-subtitle">{{ date }}</div>
          <button class="size-7.5" matButton="filled" (click)="isExpanded = !isExpanded">
            @if (isExpanded) {
              <mat-icon class="text-3xl!">keyboard_arrow_down</mat-icon>
            } @else {
              <mat-icon class="text-3xl!">keyboard_arrow_up</mat-icon>
            }
          </button>
        </div>
      </div>
    </div>
  </div>

  @if (mobile) {
    <div class="expand-wrapper" [ngClass]="{ 'is-open': isExpanded }">
      <div class="expand-inner">
        <div class="flex flex-col gap-4 pt-2">
          @for (product of ticketPendingSupply; track product.Id) {
            <div class="flex items-center gap-4">
              <img
                class="rounded-3xl bg-contain bg-center bg-no-repeat shrink-0! w-20"
                [src]="`../../../../assets/img/PNGs/${product?.Supply?.Code}.png`"
                [alt]="product?.Supply?.Description"
              />
              <div>
                <div>{{ product?.Supply?.Description }}</div>
                <div class="text-general-subtitle">{{ product?.Quantity }} unidades</div>
                <div class="text-general-subtitle">
                  ${{ ((product?.Quantity ?? 0) * (product?.Supply?.Cost ?? 0)).toFixed(2) }}
                </div>
              </div>
            </div>
          }
          <div class="flex justify-start items-center gap-4">
            {{ folio ? 'Folio: ' + folio : '' }}
          </div>
        </div>
      </div>
    </div>
  }
</div>
